module.exports = __webpack_public_path__ + "img/gatech.aa2e0ff8.png";